module.exports = __webpack_public_path__ + "img/lock-keyhole-open.87f71ee1.svg";